import { Inject, Injectable, InjectionToken } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import {
  Observable,
  Subject,
  catchError,
  finalize,
  of,
  takeUntil,
  tap,
  TimeoutError,
  empty,
  throwError,
} from 'rxjs';
import { timeout } from 'rxjs/operators';
import { AppConst } from 'src/app/app.constants';
import { Router } from '@angular/router';
import { ToastService } from '../toastService/toast-service';
import { UtilityService } from '../utility/utility.service';

export const DEFAULT_TIMEOUT = new InjectionToken<number>('defaultTimeout');

@Injectable()
export class HttpConfigInterceptorInterceptor implements HttpInterceptor {
  countryStore = {115:'uae',118:'uk'};
  private pendingHTTPRequests$ = new Subject<void>();
  count: number = 0;
  constructor(
    private router: Router,
    private toastService: ToastService,
    private utility: UtilityService,
    @Inject(DEFAULT_TIMEOUT) protected defaultTimeout,
  ) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    /* request.headers.get('timeout')
      ? Number(request.headers.get('timeout'))
      :  */
    const timeOut = request.headers.get('timeout') ? Number(request.headers.get('timeout')) : this.defaultTimeout;
    return next.handle(request).pipe(
      tap((evt) => {
        if (evt instanceof HttpResponse) {
          if (evt.body && evt.body.status !== 0) {
            if (evt.body.title === 'ERR0000044444') {
              const getEvtTitle = evt.body.title;
              const findClientTitle =
                AppConst.API_ERROR_MESSAGES[0].value.findIndex(
                  (x) => x.error_code === getEvtTitle,
                );
              if (findClientTitle > -1) {
                // const storeId = JSON.parse(localStorage.getItem('userData'))['storeId'];
                this.utility.signOutUser();
                /* (isObserver !== null && isObserver === '1')
                  ? storeId !==100?
                  this.router.navigate([`pre-auth/${this.countryStore[storeId]}/observer-login`]) : 
                  this.router.navigate(['pre-auth/observer-login'])
                  : storeId !==100?this.router.navigate([`pre-auth/${this.countryStore[storeId]}/login`]):this.router.navigate(['pre-auth/login']); */
                localStorage.removeItem('userData');
                this.showToastMessage(evt.body.detail);
              }
            } else if((evt.body?.hasOwnProperty('status'))){
              throwError(() => evt.body?.detail);
            }
          } else {
            takeUntil(this.onCancelPendingRequests());
          }
        }
      }),
      timeout(timeOut),
      catchError((err: any) => {
        let errorMsg = '';
        if (err instanceof HttpErrorResponse) {
          try {
            if (err.status === AppConst.HTTP_STATUS.BAD_REQUEST) {
              errorMsg = AppConst.API_MESSAGES[500];
            } else if (
              err.status === AppConst.HTTP_STATUS.INTERNAL_SERVER_ERROR
            ) {
              errorMsg = AppConst.API_MESSAGES[500];
            } else if (err.status === AppConst.HTTP_STATUS.UN_AUTHORIZED) {
              errorMsg = AppConst.API_MESSAGES[401];
            } else if (err.status === AppConst.HTTP_STATUS.NOT_FOUND) {
              errorMsg = AppConst.API_MESSAGES[404];
            } else if (
              err.status === AppConst.HTTP_STATUS.SERVICE_UNAVAILABLE_ERROR
            ) {
              errorMsg = AppConst.API_MESSAGES[503];
            } else {
              errorMsg = AppConst.API_MESSAGES[503];
            }
          } catch (e) {
            errorMsg = AppConst.API_MESSAGES[503];
          }
          /* if (err.error instanceof ErrorEvent) {
            //console.log('This is client side error');
            errorMsg = AppConst.API_MESSAGES[503];
          } else {
            //console.log('This is server side error');
            errorMsg = AppConst.API_MESSAGES[500];
          } */
        }
        if (err instanceof TimeoutError) {
          //console.error('Timeout has occurred', request.url);
          errorMsg = 'API Timeout';
        }
        ////console.log(errorMsg);
        return throwError(() => errorMsg);
        return of(err);
      }),
      finalize(() => {}),
    );
  }

  private showToastMessage(message: string) {
    this.count === 0
      ? this.toastService.showErrorToast('Error toast title', message)
      : null;
    this.count++;
  }

  private onCancelPendingRequests() {
    return this.pendingHTTPRequests$.asObservable();
  }
}
